// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Store = require("../../../shared/src/Store.bs.js");
var Paging = require("../../../shared/src/Paging.bs.js");
var DateUtils = require("../../../shared/src/DateUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebTypes_Shift = require("../types/WebTypes_Shift.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var WebGraphql_ToDo = require("../graphql/WebGraphql_ToDo.bs.js");
var Relude_AsyncData = require("relude/src/Relude_AsyncData.bs.js");
var WebGraphql_Shifts = require("../graphql/WebGraphql_Shifts.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var WebStore_ThunkHelpers = require("./WebStore_ThunkHelpers.bs.js");
var WebStore_Types_Action = require("./WebStore_Types_Action.bs.js");

function getter(param) {
  return param.dashboard;
}

function setter(dashboard, state) {
  return {
          cities: state.cities,
          currentUser: state.currentUser,
          dashboard: dashboard,
          editingShift: state.editingShift,
          layout: state.layout,
          postAShift: state.postAShift,
          savedBusinessAdmins: state.savedBusinessAdmins,
          savedBusinessManagers: state.savedBusinessManagers,
          savedLocations: state.savedLocations,
          token: state.token,
          timing: state.timing,
          view: state.view
        };
}

var LensedThunkHelpers = Curry._1(WebStore_ThunkHelpers.Lens, {
      getter: getter,
      setter: setter,
      actionWrapper: WebStore_Types_Action.dashboard
    });

function updateShiftsArray(newShifts, state) {
  var dashboard = state.dashboard;
  return {
          cities: state.cities,
          currentUser: state.currentUser,
          dashboard: {
            pastPageMarker: dashboard.pastPageMarker,
            shifts: Curry._3(Relude_Array.foldRight, WebTypes_Shift.$$Set.update, dashboard.shifts, newShifts),
            subscriptions: dashboard.subscriptions,
            upcomingPageMarker: dashboard.upcomingPageMarker
          },
          editingShift: state.editingShift,
          layout: state.layout,
          postAShift: state.postAShift,
          savedBusinessAdmins: state.savedBusinessAdmins,
          savedBusinessManagers: state.savedBusinessManagers,
          savedLocations: state.savedLocations,
          token: state.token,
          timing: state.timing,
          view: state.view
        };
}

function updateShiftsSet(newShifts, state) {
  return updateShiftsArray(Curry._1(WebTypes_Shift.$$Set.toArray, newShifts), state);
}

function updatePageMarkerAndShifts(getPageMarkerFromState, setPageMarker, state, param) {
  var exit = 0;
  var data;
  var result;
  var result$1;
  if (typeof param === "number") {
    if (param === /* Init */0) {
      return Store.noUpdate;
    } else {
      return Store.update(Curry._2(setPageMarker, state, Relude_AsyncData.toBusy(Curry._1(getPageMarkerFromState, state))));
    }
  }
  if (param.TAG === /* Reloading */0) {
    var match = param._0;
    if (match.TAG === /* Ok */0) {
      data = match._0.data;
      result = param;
      exit = 1;
    } else {
      result$1 = param;
      exit = 2;
    }
  } else {
    var match$1 = param._0;
    if (match$1.TAG === /* Ok */0) {
      data = match$1._0.data;
      result = param;
      exit = 1;
    } else {
      result$1 = param;
      exit = 2;
    }
  }
  switch (exit) {
    case 1 :
        return Store.update(updateShiftsSet(data, Curry._2(setPageMarker, state, Relude_AsyncResult.map(Paging.PagedData.getPageMarkers, result))));
    case 2 :
        var __x = Curry._2(setPageMarker, state, Relude_AsyncResult.map(Paging.PagedData.getPageMarkers, result$1));
        return Store.updateWithSideEffects(__x, (function (_state, _dispatch) {
                      return Relude_IO.$$throw(Store.known(/* UpdatePageMarkerAndShiftsError */0));
                    }));
    
  }
}

function reducer(param) {
  var shift = param[0];
  if (typeof shift === "number") {
    switch (shift) {
      case /* FetchPayTipsToDos */0 :
          var partial_arg = [];
          var partial_arg$1 = function (param) {
            return Relude_Option.getOrElse(partial_arg, param);
          };
          var partial_arg$2 = function (param) {
            return Relude_Globals.$great$great(Relude_AsyncResult.getOk, partial_arg$1, param);
          };
          return Store.sideEffects(Curry._3(LensedThunkHelpers.loadAsyncData, undefined, (function (param) {
                            return Relude_Globals.$great$great(partial_arg$2, WebStore_Types_Action.Dashboard.updateManyShifts, param);
                          }), Curry._1(WebGraphql_ToDo.GetPayTipsToDos.queryAsyncResult, undefined)));
      case /* FetchShifts */1 :
          var match = param[1];
          var match$1 = match.dashboard;
          var pastPageMarker = match$1.pastPageMarker;
          var exit = 0;
          var upcomingPageMarker = match$1.upcomingPageMarker;
          var exit$1 = 0;
          var match$2 = match.view;
          if (typeof match$2 === "number") {
            return Store.noUpdate;
          }
          if (match$2.TAG !== /* BusinessDashboard */0) {
            return Store.noUpdate;
          }
          var tmp = match$2._0;
          if (typeof tmp === "number") {
            return Store.noUpdate;
          }
          if (tmp.TAG !== /* ShiftsList */1) {
            return Store.noUpdate;
          }
          if (typeof upcomingPageMarker === "number") {
            exit$1 = upcomingPageMarker === /* Init */0 ? 3 : 4;
          } else if (upcomingPageMarker.TAG === /* Reloading */0) {
            exit$1 = 4;
          } else {
            var match$3 = upcomingPageMarker._0;
            if (match$3.TAG === /* Ok */0) {
              var match$4 = match$3._0.next;
              exit$1 = typeof match$4 === "number" && match$4 !== 0 ? 4 : 3;
            } else {
              exit$1 = 4;
            }
          }
          switch (exit$1) {
            case 3 :
                var match$5 = match.view;
                if (typeof match$5 === "number" || match$5.TAG !== /* BusinessDashboard */0) {
                  exit = 2;
                } else {
                  var match$6 = match$5._0;
                  if (typeof match$6 === "number" || match$6.TAG !== /* ShiftsList */1) {
                    exit = 2;
                  } else {
                    if (match$6._0) {
                      return Store.sideEffects(Curry._3(LensedThunkHelpers.loadAsyncData, undefined, WebStore_Types_Action.Dashboard.updateUpcomingShifts, (function (authorizedClient) {
                                        return Paging.getPage(100, (function (pageInfo) {
                                                      return Relude_IO.flatMap((function (cutoff) {
                                                                    return Curry._2(WebGraphql_Shifts.GetUpcomingShiftsForBusiness.queryAsyncResult, {
                                                                                pageInfo: pageInfo,
                                                                                cutoff: cutoff
                                                                              }, authorizedClient);
                                                                  }), DateUtils.getNowInIO(undefined));
                                                    }), /* Next */0, (function (prev) {
                                                      return Curry._1(WebTypes_Shift.$$Set.union, prev);
                                                    }), Relude_Option.fold(Paging.PagedData.make(WebTypes_Shift.$$Set.empty), (function (param) {
                                                          return Paging.PagedData.makeWithPageMarkers(WebTypes_Shift.$$Set.empty, param);
                                                        }), Relude_AsyncResult.getOk(upcomingPageMarker)));
                                      })));
                    }
                    exit = 2;
                  }
                }
                break;
            case 4 :
                var match$7 = match.view;
                if (typeof match$7 === "number" || match$7.TAG !== /* BusinessDashboard */0) {
                  exit = 2;
                } else {
                  var match$8 = match$7._0;
                  if (typeof match$8 === "number" || match$8.TAG !== /* ShiftsList */1) {
                    exit = 2;
                  } else {
                    if (match$8._0) {
                      return Store.noUpdate;
                    }
                    exit = 2;
                  }
                }
                break;
            
          }
          if (exit === 2) {
            if (typeof pastPageMarker === "number") {
              if (pastPageMarker !== /* Init */0) {
                return Store.noUpdate;
              }
              
            } else {
              if (pastPageMarker.TAG === /* Reloading */0) {
                return Store.noUpdate;
              }
              var match$9 = pastPageMarker._0;
              if (match$9.TAG !== /* Ok */0) {
                return Store.noUpdate;
              }
              var match$10 = match$9._0.next;
              if (typeof match$10 === "number" && match$10 !== 0) {
                return Store.noUpdate;
              }
              
            }
          }
          return Store.sideEffects(Curry._3(LensedThunkHelpers.loadAsyncData, undefined, WebStore_Types_Action.Dashboard.updatePastShifts, (function (authorizedClient) {
                            return Paging.getPage(100, (function (pageInfo) {
                                          return Relude_IO.flatMap((function (cutoff) {
                                                        return Curry._2(WebGraphql_Shifts.GetPastShiftsForBusiness.queryAsyncResult, {
                                                                    pageInfo: pageInfo,
                                                                    cutoff: cutoff
                                                                  }, authorizedClient);
                                                      }), DateUtils.getNowInIO(undefined));
                                        }), /* Next */0, (function (prev) {
                                          return Curry._1(WebTypes_Shift.$$Set.union, prev);
                                        }), Relude_Option.fold(Paging.PagedData.make(WebTypes_Shift.$$Set.empty), (function (param) {
                                              return Paging.PagedData.makeWithPageMarkers(WebTypes_Shift.$$Set.empty, param);
                                            }), Relude_AsyncResult.getOk(pastPageMarker)));
                          })));
      case /* StartSubscriptions */2 :
          var match$11 = param[1];
          var match$12 = match$11.currentUser;
          if (typeof match$12 === "number") {
            return Store.noUpdate;
          }
          if (match$12.TAG !== /* Complete */1) {
            return Store.noUpdate;
          }
          var match$13 = match$12._0;
          if (match$13.TAG !== /* Ok */0) {
            return Store.noUpdate;
          }
          var match$14 = match$13._0;
          if (typeof match$14 === "number") {
            return Store.noUpdate;
          }
          if (match$11.dashboard.subscriptions !== undefined) {
            return Store.sideEffects(function (_state, dispatch) {
                        var partial_arg = Curry._1(dispatch, WebStore_Types_Action.dashboard(WebStore_Types_Action.Dashboard.startSubscriptions));
                        return Relude_IO.flatMap((function (param) {
                                      return Relude_Globals.$$const(partial_arg, param);
                                    }), Curry._1(dispatch, WebStore_Types_Action.dashboard(WebStore_Types_Action.Dashboard.stopSubscriptions)));
                      });
          }
          var businessId = match$14._0.business.id;
          return Store.sideEffects(function (store, dispatch) {
                      return Relude_IO.flatMap((function (authorizedClient) {
                                    var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
                                            
                                          }));
                                    var partial_arg$1 = Relude_IO.pure(undefined);
                                    var partial_arg$2 = function (param) {
                                      return Relude_Option.fold(partial_arg$1, (function (param) {
                                                    return Relude_Globals.$great$great((function (param) {
                                                                  return Relude_Globals.$great$great(WebStore_Types_Action.Dashboard.updateShift, WebStore_Types_Action.dashboard, param);
                                                                }), dispatch, param);
                                                  }), param);
                                    };
                                    var partial_arg$3 = function (param) {
                                      return Relude_Globals.$great$great(Relude_Result.getOk, partial_arg$2, param);
                                    };
                                    var partial_arg$4 = Curry._1(Relude_IO.mapError, (function (prim) {
                                            
                                          }));
                                    var partial_arg$5 = Relude_IO.pure(undefined);
                                    var partial_arg$6 = function (param) {
                                      return Relude_Option.fold(partial_arg$5, (function (param) {
                                                    return Relude_Globals.$great$great((function (param) {
                                                                  return Relude_Globals.$great$great(WebStore_Types_Action.Dashboard.updateShift, WebStore_Types_Action.dashboard, param);
                                                                }), dispatch, param);
                                                  }), param);
                                    };
                                    var partial_arg$7 = function (param) {
                                      return Relude_Globals.$great$great(Relude_Result.getOk, partial_arg$6, param);
                                    };
                                    var partial_arg$8 = Curry._1(Relude_IO.mapError, (function (prim) {
                                            
                                          }));
                                    var partial_arg$9 = Relude_IO.pure(undefined);
                                    var partial_arg$10 = function (param) {
                                      return Relude_Option.fold(partial_arg$9, (function (param) {
                                                    return Relude_Globals.$great$great((function (param) {
                                                                  return Relude_Globals.$great$great(WebStore_Types_Action.Dashboard.updateShift, WebStore_Types_Action.dashboard, param);
                                                                }), dispatch, param);
                                                  }), param);
                                    };
                                    var partial_arg$11 = function (param) {
                                      return Relude_Globals.$great$great(Relude_Result.getOk, partial_arg$10, param);
                                    };
                                    var partial_arg$12 = Curry._1(Relude_IO.mapError, (function (prim) {
                                            
                                          }));
                                    var partial_arg$13 = Relude_IO.pure(undefined);
                                    var partial_arg$14 = function (param) {
                                      return Relude_Option.fold(partial_arg$13, (function (param) {
                                                    return Relude_Globals.$great$great((function (param) {
                                                                  return Relude_Globals.$great$great(WebStore_Types_Action.Dashboard.updateShift, WebStore_Types_Action.dashboard, param);
                                                                }), dispatch, param);
                                                  }), param);
                                    };
                                    var partial_arg$15 = function (param) {
                                      return Relude_Globals.$great$great(Relude_Result.getOk, partial_arg$14, param);
                                    };
                                    return Curry._1(dispatch, WebStore_Types_Action.dashboard(WebStore_Types_Action.Dashboard.setSubscriptions({
                                                        shiftCreated: Curry._4(WebGraphql_ToDo.Subscription.ShiftCreated.subscribe, undefined, businessId, (function (param) {
                                                                return Relude_Globals.$great$great(partial_arg$3, partial_arg, param);
                                                              }), authorizedClient),
                                                        shiftUpdated: Curry._4(WebGraphql_ToDo.Subscription.ShiftUpdated.subscribe, undefined, businessId, (function (param) {
                                                                return Relude_Globals.$great$great(partial_arg$7, partial_arg$4, param);
                                                              }), authorizedClient),
                                                        workerShiftCreated: Curry._4(WebGraphql_ToDo.Subscription.WorkerShiftCreated.subscribe, undefined, businessId, (function (param) {
                                                                return Relude_Globals.$great$great(partial_arg$11, partial_arg$8, param);
                                                              }), authorizedClient),
                                                        workerShiftUpdated: Curry._4(WebGraphql_ToDo.Subscription.WorkerShiftUpdated.subscribe, undefined, businessId, (function (param) {
                                                                return Relude_Globals.$great$great(partial_arg$15, partial_arg$12, param);
                                                              }), authorizedClient)
                                                      })));
                                  }), Curry._2(WebStore_ThunkHelpers.getAuthorizedClientForIO, dispatch, store));
                    });
      case /* StopSubscriptions */3 :
          var state = param[1];
          var dashboard = state.dashboard;
          var match$15 = dashboard.subscriptions;
          if (match$15 === undefined) {
            return Store.noUpdate;
          }
          var workerShiftUpdated = match$15.workerShiftUpdated;
          var workerShiftCreated = match$15.workerShiftCreated;
          var shiftUpdated = match$15.shiftUpdated;
          var shiftCreated = match$15.shiftCreated;
          return Store.updateWithSideEffects({
                      cities: state.cities,
                      currentUser: state.currentUser,
                      dashboard: {
                        pastPageMarker: dashboard.pastPageMarker,
                        shifts: dashboard.shifts,
                        subscriptions: undefined,
                        upcomingPageMarker: dashboard.upcomingPageMarker
                      },
                      editingShift: state.editingShift,
                      layout: state.layout,
                      postAShift: state.postAShift,
                      savedBusinessAdmins: state.savedBusinessAdmins,
                      savedBusinessManagers: state.savedBusinessManagers,
                      savedLocations: state.savedLocations,
                      token: state.token,
                      timing: state.timing,
                      view: state.view
                    }, (function (_store, _dispatch) {
                        return Relude_IO.map(Relude_List.foldLeft((function (param) {
                                          return function (prim) {
                                            prim.unsubscribe();
                                            
                                          };
                                        }), undefined), Relude_IO.pure({
                                        hd: shiftCreated,
                                        tl: {
                                          hd: shiftUpdated,
                                          tl: {
                                            hd: workerShiftCreated,
                                            tl: {
                                              hd: workerShiftUpdated,
                                              tl: /* [] */0
                                            }
                                          }
                                        }
                                      }));
                      }));
      
    }
  } else {
    switch (shift.TAG | 0) {
      case /* CancelShift */0 :
          return Store.sideEffects(Curry._3(LensedThunkHelpers.runAsyncMutation, undefined, WebStore_Types_Action.Dashboard.updateShift, Curry._1(WebGraphql_Shifts.CancelShift.mutateStoreError, shift._0)));
      case /* PayTips */1 :
          return Store.sideEffects(Curry._3(LensedThunkHelpers.runAsyncMutation, undefined, WebStore_Types_Action.Dashboard.updateManyShifts, Curry._1(WebGraphql_ToDo.PayTips.mutateStoreError, shift._0)));
      case /* SetSubscriptions */2 :
          var state$1 = param[1];
          var dashboard$1 = state$1.dashboard;
          return Store.update({
                      cities: state$1.cities,
                      currentUser: state$1.currentUser,
                      dashboard: {
                        pastPageMarker: dashboard$1.pastPageMarker,
                        shifts: dashboard$1.shifts,
                        subscriptions: Relude_Option.pure(shift._0),
                        upcomingPageMarker: dashboard$1.upcomingPageMarker
                      },
                      editingShift: state$1.editingShift,
                      layout: state$1.layout,
                      postAShift: state$1.postAShift,
                      savedBusinessAdmins: state$1.savedBusinessAdmins,
                      savedBusinessManagers: state$1.savedBusinessManagers,
                      savedLocations: state$1.savedLocations,
                      token: state$1.token,
                      timing: state$1.timing,
                      view: state$1.view
                    });
      case /* UpdateManyShifts */3 :
          return Store.update(updateShiftsArray(shift._0, param[1]));
      case /* UpdatePastShifts */4 :
          return updatePageMarkerAndShifts((function (param) {
                        return param.dashboard.pastPageMarker;
                      }), (function (state, pastPageMarker) {
                        var dashboard = state.dashboard;
                        return {
                                cities: state.cities,
                                currentUser: state.currentUser,
                                dashboard: {
                                  pastPageMarker: pastPageMarker,
                                  shifts: dashboard.shifts,
                                  subscriptions: dashboard.subscriptions,
                                  upcomingPageMarker: dashboard.upcomingPageMarker
                                },
                                editingShift: state.editingShift,
                                layout: state.layout,
                                postAShift: state.postAShift,
                                savedBusinessAdmins: state.savedBusinessAdmins,
                                savedBusinessManagers: state.savedBusinessManagers,
                                savedLocations: state.savedLocations,
                                token: state.token,
                                timing: state.timing,
                                view: state.view
                              };
                      }), param[1], shift._0);
      case /* UpdateShift */5 :
          var state$2 = param[1];
          var dashboard$2 = state$2.dashboard;
          return Store.update({
                      cities: state$2.cities,
                      currentUser: state$2.currentUser,
                      dashboard: {
                        pastPageMarker: dashboard$2.pastPageMarker,
                        shifts: Curry._2(WebTypes_Shift.$$Set.update, shift._0, dashboard$2.shifts),
                        subscriptions: dashboard$2.subscriptions,
                        upcomingPageMarker: dashboard$2.upcomingPageMarker
                      },
                      editingShift: state$2.editingShift,
                      layout: state$2.layout,
                      postAShift: state$2.postAShift,
                      savedBusinessAdmins: state$2.savedBusinessAdmins,
                      savedBusinessManagers: state$2.savedBusinessManagers,
                      savedLocations: state$2.savedLocations,
                      token: state$2.token,
                      timing: state$2.timing,
                      view: state$2.view
                    });
      case /* UpdateUpcomingShifts */6 :
          return updatePageMarkerAndShifts((function (param) {
                        return param.dashboard.upcomingPageMarker;
                      }), (function (state, upcomingPageMarker) {
                        var dashboard = state.dashboard;
                        return {
                                cities: state.cities,
                                currentUser: state.currentUser,
                                dashboard: {
                                  pastPageMarker: dashboard.pastPageMarker,
                                  shifts: dashboard.shifts,
                                  subscriptions: dashboard.subscriptions,
                                  upcomingPageMarker: upcomingPageMarker
                                },
                                editingShift: state.editingShift,
                                layout: state.layout,
                                postAShift: state.postAShift,
                                savedBusinessAdmins: state.savedBusinessAdmins,
                                savedBusinessManagers: state.savedBusinessManagers,
                                savedLocations: state.savedLocations,
                                token: state.token,
                                timing: state.timing,
                                view: state.view
                              };
                      }), param[1], shift._0);
      
    }
  }
}

function reducer$1(param, param$1) {
  return Relude_Globals.flip((function (param, param$1) {
                return Relude_Function.curry2(reducer, param, param$1);
              }), param, param$1);
}

exports.LensedThunkHelpers = LensedThunkHelpers;
exports.updateShiftsArray = updateShiftsArray;
exports.updateShiftsSet = updateShiftsSet;
exports.updatePageMarkerAndShifts = updatePageMarkerAndShifts;
exports.reducer = reducer$1;
/* LensedThunkHelpers Not a pure module */
